import React, { useEffect, useState, useCallback, useMemo, memo } from "react";
import { useParams } from "react-router-dom";
import {
  Encrypt_Value,
  Decrypt_Value,
} from "../../MiddleWare/EncryptDecrypt/index.js";
import axiosInstance from "../../axios/axios";
import { AutoComplete, Checkbox } from "antd";
import { Button, Modal, Form, Spinner } from "react-bootstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { IoCloseSharp } from "react-icons/io5";
import { BsCheckCircle } from "react-icons/bs";
import GetStartedPopup from "../popups/GetStartedPopup";
import { Popup } from "semantic-ui-react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min.js";

const provider = localStorage.getItem("user_id")
  ? Decrypt_Value(localStorage.getItem("user_id"), "vozo")
  : "";

const IntakeForms = (props) => {
  let history = useHistory();
  const {
    toShow,
    toHide,
    patientName,
    patientMail = "",
    from,
    sendemailClick = () => {},
    addemailClick = () => {},
    refreshComp = () => {},
    patientId,
    reopenStepSixTooltip,
  } = props;
  const params = useParams();
  const location = useLocation();
  const step = new URLSearchParams(location.search).get("step");

  const doctype = "All";
  const specialty = "All";

  const [allIntakeForms, setAllIntakeForms] = useState([]);
  const [selectedIntakeForms, setSelectedIntakeForms] = useState([]);
  const [loadingTemplates, setLoadingTemplates] = useState(true);
  const [showStepFiveIntro, setShowStepFiveIntro] = useState(false);
  const [showStepSevenIntro, setShowStepSevenIntro] = useState(false);
  const [showStepNineIntro, setShowStepNineIntro] = useState(false);
  const [search, setSearch] = useState("");
  const [source, setSource] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ModalAlerShow, setModalAlerShow] = useState(false);
  const [ModalAlerShow1, setModalAlerShow1] = useState(false);
  const [ModalMsg, setModalMsg] = useState("");
  const [requireSign, setRequireSign] = useState(false);
  const [isManuallyClosed, setIsManuallyClosed] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const modClose1 = () => setModalAlerShow1(false);
  const modClose = () => setModalAlerShow(false);
  const userID = Decrypt_Value(localStorage.getItem("user_id"), "vozo");

  const handleModalHide = () => {
    setIsManuallyClosed(true);
    toHide();
  };

  const fetchTemplates = useCallback(async () => {
    setLoadingTemplates(true);
    setLoading(true);

    const query =
      "formname=" +
      "&doctype=" +
      doctype +
      "&speciality=" +
      specialty;

    try {
      const encrypted = Encrypt_Value(query, "vozo");
      const response = await axiosInstance.get(
        `/vozo/patient/templatelibrary/data?search=${encrypted}&notetype=1`,
      );

      const decrypted = Decrypt_Value(response.data, "vozo") || [];

      // Remove duplicates by ID
      const uniqueData = Array.from(
        new Map(decrypted.map((item) => [item.id, item])).values(),
      );

      setSource(uniqueData);
      setAllIntakeForms(uniqueData);

      setSelectedIntakeForms((prev) =>
        prev.length === 0
          ? uniqueData.filter((f) => f.intake_forms === 1)
          : prev,
      );
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      setLoadingTemplates(false);
    }
  }, []);

  useEffect(() => {
    if (toShow) {
      setSearch("");
      fetchTemplates();
    }
  }, [toShow, fetchTemplates]);

  const handleAddIntakeForm = (id) => {
    const selectedDoc = source.find((x) => x.id == id);
    if (!selectedDoc) return;

    setSelectedIntakeForms((prev) => {
      if (prev.some((f) => f.id === selectedDoc.id)) return prev;
      return [...prev, { ...selectedDoc, intake_forms: 1 }];
    });

    setSearch("");
  };

  const handleToggle = (id) => {
    setSelectedIntakeForms((prev) =>
      prev.map((f) =>
        f.id === id ? { ...f, intake_forms: f.intake_forms ? 0 : 1 } : f,
      ),
    );
  };

  const handleSendForms = async () => {
    setDisabled(true);
    const formsToSend = selectedIntakeForms.filter((f) => f.intake_forms === 1);

    if (formsToSend.length === 0) {
      setModalMsg("Please select at least one form");
      setModalAlerShow1(true);
      setTimeout(() => {
        setModalAlerShow1(false);
      }, 1000);
      return;
    }

    const RedefinedDocName = formsToSend.map((doc) => {
      // Skip if doc_name is null, undefined, or doesn't contain "-txt"
      if (!doc.doc_name || !doc.doc_name.includes("-txt")) {
        return doc.doc_name; // or return null, or return the original doc_name
      }

      const lastIndex = doc.doc_name.lastIndexOf("-txt");
      const randomNumber = Math.floor(Math.random() * 1001);
      const sanitized = doc.doc_name.replace(/[.,;]/g, "_");
      return (
        sanitized.slice(0, lastIndex) +
        `-${randomNumber}` +
        sanitized.slice(lastIndex)
      );
    });

    const article = {
      id: formsToSend.map((d) => d.id),
      file_path: formsToSend.map((d) => d.file_url),
      doc_name: RedefinedDocName,
      form_name: formsToSend.map(
        (d) => d.form_name + Math.floor(Math.random() * 1001),
      ),
      multi_select_number: "",
      editpatientshare: [patientId || params.pid],
      editpatsign: requireSign,
      patSelectAll: "No",
      uid: provider,
      type: "Template",
      reason: "",
      showInDocumentsTab: 1,
    };

    try {
      const encrypted = Encrypt_Value(article, "vozo");
      await axiosInstance.post(
        "/vozo/insertdocumenttemplate/patient",
        encrypted,
      );

      setModalMsg("Forms Sent Successfully!");
      setModalAlerShow(true);
      setDisabled(false);

      // Reset manual close flag
      setIsManuallyClosed(false);

      setTimeout(() => {
        setModalAlerShow(false);

        setTimeout(() => {
          // Only execute if modal wasn't manually closed
          if (!isManuallyClosed) {
            toHide();
            // if (from === "portal" || from === "create_client") {
            //   if (patientMail != "") {
            //     sendemailClick();
            //   } else {
            //     addemailClick();
            //   }
            // }
          }
        }, 500);
      }, 1500);
    } catch (err) {
      console.error(err);
      setModalMsg("Failed to Send Document");
      setModalAlerShow1(true);
    } finally {
      refreshComp();
    }
  };

  const handleSkipForNow = () => {
    toHide();
    // if (patientMail != "") {
    //   sendemailClick();
    // } else {
    //   addemailClick();
    // }
  };

  const autoCompleteOptions = useMemo(
    () =>
      source
        .filter((item) =>
          item.form_name.toLowerCase().includes(search.toLowerCase()),
        )
        .map((x) => ({
          value: String(x.id),
          label: <div className="toplabel">{x.form_name}</div>,
        })),
    [source, search],
  );
  const handleIntroBack = () => {
    setShowStepFiveIntro(false);

    toHide();

    history.replace({
      pathname: "/patient/patientlist",
      search: "?step=23.4",
    });
  };

  const handleGotIt = async () => {
    try {
      await axiosInstance.post(
        `/vozo/account-setup/complete-step?patient_id=${userID}&step_id=23`,
      );
    } catch (error) {
      console.error("Failed to mark step as complete", error);
    }
      history.push("/settings/accountsetup");
  };

  useEffect(() => {
    if (!toShow) return;

    if (step === "23.7") {
      setShowStepFiveIntro(false);
      setShowStepSevenIntro(true);
      setShowStepNineIntro(false);
    } else if (step === "23.9") {
      setShowStepFiveIntro(false);
      setShowStepSevenIntro(false);
      setShowStepNineIntro(true);
    } else if (step === "23.5") {
      setShowStepFiveIntro(true);
      setShowStepSevenIntro(false);
      setShowStepNineIntro(false);
    } else {
      setShowStepFiveIntro(false);
      setShowStepSevenIntro(false);
      setShowStepNineIntro(false);
    }
  }, [toShow, step]);

  return (
    <>
      <Modal
        className="up-doc-modal popup_centre"
        centered
        show={toShow}
        onHide={handleModalHide}
      >
        <div style={{ position: "relative" }}>
          <Modal.Header closeButton>
            <div className="ed-doc-mod-title">
              Send {patientName} the following templates
            </div>
          </Modal.Header>
          {/* <Popup
            open={showStepFiveIntro}
            onClose={() => setShowStepFiveIntro(false)}
            position="left center"
            pinned
            trigger={<span />}
            content={
              <GetStartedPopup
                title="Sending Intake Forms"
                description="Select the forms you want to send to the patient."
                currentStep={5}
                totalSteps={9}
                onBack={() => {}}
                onNext={() => {}}
              />
            }
          /> */}

          <Modal.Body className="ed-doc-mod-body" id="cnst_frm-mod_bdy">
            {loadingTemplates ? (
              <div style={{ textAlign: "center", padding: "40px" }}>
                <Spinner animation="border" />
                <div
                  style={{ marginTop: "10px", fontSize: "14px", color: "#555" }}
                >
                  Loading intake forms...
                </div>
              </div>
            ) : (
              <>
                <Popup
                  open={showStepFiveIntro}
                  position="left center"
                  offset={[30, 10]}
                  pinned
                  content={
                    <GetStartedPopup
                      title="Sending Intake Forms"
                      description="Select the forms you want to send to the patient."
                      currentStep={5}
                      totalSteps={9}
                      onBack={handleIntroBack}
                      onNext={() => {
                        setShowStepFiveIntro(false);

                        toHide();

                        history.replace({
                          pathname: `/patient/clientportalaccess/${patientId || params.pid}`,
                          search: "?step=23.6",
                        });
                      }}
                      onClose={() => setShowStepFiveIntro(false)}
                    />
                    
                  }
                  trigger={
                    <Form.Row className="c_f_u_d_f_r m-b-20">
                      <Form.Group style={{ width: "100%" }}>
                        <div
                          className="for_autoComplete_bi"
                          style={{
                            width: "100% !important",
                            marginTop: "2px",
                            marginLeft: "-20px",
                          }}
                        >
                          <AiOutlineSearch />
                          <AutoComplete
                            virtual={false}
                            placeholder="Search documents"
                            className="remainderWidthSheet"
                            style={{ width: "99%" }}
                            value={search}
                            onSearch={setSearch}
                            onSelect={handleAddIntakeForm}
                            notFoundContent={
                              loading ? "loading..." : "No Result Found"
                            }
                            options={autoCompleteOptions}
                          />
                        </div>
                      </Form.Group>
                    </Form.Row>
                  }
                />

                <Popup
                  open={showStepSevenIntro}
                  position="left center"
                  offset={[30, 10]}
                  pinned
                  content={
                    <GetStartedPopup
                      title="Send Intake Form"
                      description="Select the forms you want to send to the patient and click on the send button."
                      currentStep={7}
                      totalSteps={9}
                      onBack={() => {
                        setShowStepSevenIntro(false);

                        toHide(); // close IntakeForms modal

                        history.replace({
                          pathname: `/patient/clientportalaccess/${patientId || params.pid}`,
                          search: "?step=23.6",
                        });
                      }}
                      onNext={() => {
                        setShowStepSevenIntro(false);
                        setShowStepFiveIntro(false);

                        toHide(); // close IntakeForms modal

                        history.replace({
                          pathname: `/patient/documents/${patientId || params.pid}`,
                          search: "?step=23.8",
                        });
                      }}
                    />
                  }
                  trigger={<span />}
                />

                <Popup
                  open={showStepNineIntro}
                  position="left center"
                  pinned
                  content={
                    <GetStartedPopup
                      title="Sending Intake Forms"
                      description="Select the forms you want to send to the patient and click on the send button."
                      currentStep={9}
                      totalSteps={9}
                      onBack={() => {
                        setShowStepNineIntro(false);

                        toHide();

                        history.replace({
                          pathname: `/patient/documents/${params.pid}`,
                          search: "?step=23.8",
                        });
                      }}
                      onGotIt={handleGotIt}
                      onClose={() => setShowStepNineIntro(false)}
                    />
                  }
                  trigger={<span />}
                />

                {selectedIntakeForms.map((item) => (
                  <Form.Row className="c_f_u_d_f_r c_f_u_f_r_new" key={item.id}>
                    <Checkbox
                      className="con_form_upload_checkbox con_form_upload_checkbox_new"
                      checked={!!item.intake_forms}
                      onChange={() => handleToggle(item.id)}
                    />
                    <Form.Label
                      className="con_form_up_sign black_2e"
                      style={{
                        color: item.intake_forms
                          ? "rgba(51, 51, 51, 1)"
                          : "rgba(46, 46, 46, 0.25)",
                      }}
                    >
                      {item.form_name}
                    </Form.Label>
                  </Form.Row>
                ))}
              </>
            )}
          </Modal.Body>

          <Modal.Footer className="intake-forms-request-sign">
            <Form.Row className="c_f_u_d_f_r c_f_u_f_r_new">
              <Checkbox
                className="con_form_upload_checkbox con_form_upload_checkbox_sign"
                checked={requireSign}
                onChange={(e) => setRequireSign(e.target.checked)}
              />
              <Form.Label className="con_form_up_sign con_form_up_sign_new black_2e">
                Require patient to Sign
              </Form.Label>
            </Form.Row>
            <div style={{ width: from === "documents" ? "90px" : "70px" }}>
              {""}
            </div>

            {from === "documents" ? (
              <>
                <Button
                  className="close_active add_edit_con_form_cancel_btn"
                  variant="light"
                  onClick={toHide}
                >
                  Cancel
                </Button>
                <Button
                  className="save_active add_edit_con_form_upload_btn"
                  variant="primary"
                  onClick={handleSendForms}
                  disabled={disabled}
                >
                  Send
                </Button>
              </>
            ) : (
              <>
                <Button
                  className="close_active add_edit_con_form_cancel_btn"
                  variant="light"
                  onClick={handleSkipForNow}
                  style={{ width: "107px" }}
                >
                  Skip for now
                </Button>
                <Button
                  className="save_active add_edit_con_form_upload_btn"
                  variant="primary"
                  onClick={handleSendForms}
                >
                  Send
                </Button>
              </>
            )}
          </Modal.Footer>
        </div>
      </Modal>

      <Modal
        className="alert-popup-message"
        show={ModalAlerShow1}
        onHide={modClose1}
      >
        <div className="alert msg alert-danger" role="alert">
          <IoCloseSharp className="icons-bs up-d-mod-mb" />
          <span className="up-d-mess-unsup">{ModalMsg}</span>
        </div>
      </Modal>

      <Modal
        className="alert-popup-message"
        show={ModalAlerShow}
        onHide={modClose}
      >
        <div className="alert msg alert-success" role="alert">
          <BsCheckCircle className="icons-bs" />
          {ModalMsg}
        </div>
      </Modal>
    </>
  );
};

export default memo(IntakeForms);
